// @flow
export type System = {
    system: {
        currency: string,
        fullLocale: string,
        isDesktop: boolean,
        isMobile: boolean,
        googleMapApiKey: string,
        humanReadableBrandName: string,
        siteName: string,
        locale: string,
        country: string,
    },
};

export const createSystemDataObject = ({
    currency,
    fullLocale,
    isMobile,
    isDesktop,
    googleMapApiKey,
    humanReadableBrandName,
    siteName,
    locale,
    country,
}: {
    currency: string,
    fullLocale: string,
    isDesktop: boolean,
    isMobile: boolean,
    humanReadableBrandName: string,
    googleMapApiKey: string,
    siteName: string,
    locale: string,
    country: string,
}): System => {
    return {
        system: {
            currency,
            fullLocale,
            isDesktop,
            isMobile,
            humanReadableBrandName: humanReadableBrandName || 'Vrbo',
            googleMapApiKey,
            siteName,
            locale,
            country,
        },
    };
};
